<template>
  <div class="products">
    <banner banner="product" />
    <div class="products-box flex-row">
      <div class="products-menu flex-col" v-if="isPc">
        <div v-for="item in menu" :key="item.prodId">
          <div
            :class="[
              'products-menu-item',
              'items-center',
              'little_hand',
              { active: item.prodId == prodId },
            ]"
            @click="changeProduct(item.prodId)"
          >
            <div class="line"></div>
            <h3>{{ item.prodNameEn }}</h3>
            <div
              class="more items-center little_hand"
              v-if="item.prodId == prodId"
            >
              <svg-icon icon-class="arrow"></svg-icon>
              <svg-icon icon-class="arrow"></svg-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="products-con">
        <div class="title items-end">
          <svg-icon className="icon1" icon-class="square"></svg-icon>
          <svg-icon className="icon2" icon-class="square"></svg-icon>
          <h2>
            {{ detailsRes.prodNameEn }}
            <div class="square"></div>
          </h2>
        </div>
        <div class="desc" v-html="detailsRes.prodContentEn"></div>
        <!-- <div class="products-params items-center">
          <div class="params-item flex-col">
            <h3>型号</h3>
            <span>100 SERIES</span>
          </div>
          <div class="line"></div>
          <div class="params-item flex-col">
            <h3>公称尺寸</h3>
            <span>DN150~DN300</span>
          </div>
          <div class="line"></div>
          <div class="params-item flex-col">
            <h3>公称压力</h3>
            <span>PN6/10</span>
          </div>
        </div> -->
        <div class="products-swiper-box">
          <swiper type="3" :bannerArr="bannerArr"></swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../common/banner.vue";
import Swiper from "../common/swiper.vue";
import { getProdDetails, getProdList } from "@/assets/api/products.js";

import { mapState } from "vuex";

export default {
  name: "products",
  components: {
    banner,
    Swiper,
  },
  data() {
    return {
      detailsRes: {},
      menu: [],
      bannerArr: [],
      prodId: "",
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    this.prodId = this.$route.params.id;
    this.init();
  },
  methods: {
    changeProduct(prodId) {
      this.prodId = prodId;
      this.init();
      this.$router.push({
        path: `/products-details/${prodId}`,
      });
    },
    init() {
      getProdDetails(this.prodId).then((res) => {
        this.detailsRes = res.data.data;
        this.bannerArr = res.data.data.prodImage
          ? res.data.data.prodImage.split(",")
          : [];
        this.bannerArr = this.bannerArr.map((item) => {
          item = !/^http/.test(item) ? this.$imgUrl + item : item;
          return item;
        });
        getProdList({
          orderByColumn: "orderNum",
          isAsc: "desc",
          pageNum: 1,
          pageSize: 50,
          prodTypeId: res.data.data.prodTypeId,
        }).then((res) => {
          console.log(res.data);
          this.menu = res.data.data.rows;
        });
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.products-box {
  width: 1100px;
  margin: auto;
  position: relative;
  z-index: 10;
  padding: 60px 0 80px;
  .products-menu {
    width: 240px;
    margin-right: 80px;
    .products-menu-item {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #636366;
      letter-spacing: 0;
      font-weight: 400;
      padding: 8px 0;
      .line {
        width: 24px;
        height: 1px;
        background: #636366;
        margin-right: 8px;
      }
    }
    .active {
      h3 {
        font-weight: 700;
      }
      color: #005bac;
      .line {
        width: 64px;
        height: 2px;
        background: #005bac;
      }
      .more {
        .svg-icon {
          width: 16px;
          height: 16px;
        }
        .svg-icon:last-child {
          margin-left: -8px;
        }
        margin-left: 8px;
      }
    }
  }
  .products-con {
    flex: 1;
    .title {
      .icon1 {
        width: 20px;
        height: 36px;
        color: #005bac;
      }
      .icon2 {
        width: 20px;
        height: 36px;
        color: rgba($color: #005bac, $alpha: 0.4);
        margin-left: -4px;
      }
      h2 {
        font-size: 36px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #005bac;
        line-height: 47px;
        position: relative;
        padding: 8px 20px;
        box-sizing: border-box;
        .square {
          width: 100%;
          height: 36px;
          transform: skew(-13deg);
          background-color: rgba($color: #005bac, $alpha: 0.16);
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .svg-icon {
          width: 100%;
          height: 36px;
          color: rgba($color: #005bac, $alpha: 0.16);
          object-fit: cover;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
    .desc {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2c2c2e;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 400;
      margin-top: 16px;
      margin-bottom: 24px;
    }
    .products-params {
      margin-bottom: 24px;
      .line {
        width: 1px;
        height: 44px;
        background: #e5e5ea;
        margin: 0 24px;
      }
      .params-item {
        h3 {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #2c2c2e;
          line-height: 21px;
          margin-bottom: 4px;
        }
        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #2c2c2e;
          line-height: 19px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .products-box {
    width: 100%;
    padding: 0 20px;
    margin-top: 40px;
    margin-bottom: 60px;
    .products-con {
      flex: 1;
      .title {
        .icon1 {
          width: 16px;
          height: 28px;
        }
        .icon2 {
          width: 16px;
          height: 28px;
          margin-left: -2px;
        }
        h2 {
          font-size: 24px;
          line-height: 31px;
          padding: 6px 14px;
          .square {
            width: 100%;
            height: 28px;
            transform: skew(-13deg);
          }
        }
        .more {
          font-size: 14px;
          .svg-icon {
            width: 24px;
            height: 12px;
            margin-left: 4px;
          }
        }
      }
      .desc {
        font-size: 14px;
        line-height: 24px;
      }
      .products-params {
        margin-bottom: 40px;
        justify-content: center;
        .line {
          width: 1px;
          height: 44px;
          background: #e5e5ea;
          margin: 0 24px;
        }
        .params-item {
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/en/products-details/index.vue